import { useMedia } from 'the-platform';
import React from 'react';
import styled from '@emotion/styled';
import { useLocation } from 'react-router-dom';

import { useIsNavigationVisible, useIsSideBarClosed } from 'ui/hooks';
import { breakpoints } from '../../styles/theme';
import Sidebar from '.';
import { checkIfPublicRoute } from 'app/form/helper';
import { toggleSideBarClosed } from 'ui/actions';
import { useDispatch } from 'react-redux';

const DesktopSidebarWrap = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 5;

  & + div {
    position: relative;
    margin-left: ${props => props?.closeSidebar ? '80px' : '270px'};
  }
`;

const DesktopSidebar = () => {
  const isDesktop = useMedia({ minWidth: breakpoints.lg });
  const isVisible = useIsNavigationVisible();
  const isSideBarClosed = useIsSideBarClosed()
  const dispatch = useDispatch();

  const { pathname } = useLocation();
  const isPublicRoute = checkIfPublicRoute(pathname)
  
  if (!isDesktop || !isVisible || isPublicRoute) return false;
  return (
    <DesktopSidebarWrap closeSidebar={isSideBarClosed}>
      <Sidebar closeSidebar={isSideBarClosed} setCloseSidebar={() => dispatch(toggleSideBarClosed(!isSideBarClosed))} />
    </DesktopSidebarWrap>
  );
};

export default DesktopSidebar;
